import { isCollectedFormField } from './is-collected-form-field';

export const filterCollectedFormFields = <T extends { isActive?: boolean }>(fields: T[]) =>
  fields.filter(isCollectedFormField);
